import {
  GetConsentPurposeDetailsActions,
  GetConsentPointPurposeDetailsActions,
  ConsentPointUnSubscribeOrRenewActions,
} from "./actions";

const initState = {
  consentSuccessMessage: null,
  errorMessage: null,
  consentPurposeMaster: [],
  consentPurposeDataStatus: false,
  consentPointPurposeMaster: [],
};

export default function ConsentPurpose(state = initState, { type, payload }) {
  switch (type) {
    ///////////////////////////////////////////////////////
    // GET  BY ID
    case GetConsentPurposeDetailsActions.FETCH_CONSENT_PURPOSE_DETAILS:
      return {
        ...state,
        isLoading: true,
        errorMessage: null,
        consentPurposeMaster: null,
      };
    case GetConsentPurposeDetailsActions.FETCH_CONSENT_PURPOSE_DETAILS_FULFILLED:
      return {
        ...state,
        loading: true,
        isLoading: false,
        consentPurposeMaster: payload.data && payload.data.dto && payload.data.dto.length > 0 ? payload.data.dto[0].organizationId : null,
        consentPurposeDataStatus: payload.status,
        errorMessage: null,
      };
    case GetConsentPurposeDetailsActions.FETCH_CONSENT_PURPOSE_DETAILS_REJECTED:
      return {
        ...state,
        isLoading: false,
        errorMessage: payload,
        consentPurposeMaster: null,
      };
    // GET  BY ID
    case GetConsentPointPurposeDetailsActions.FETCH_CONSENT_POINT_PURPOSE_DETAILS:
      return {
        ...state,
        isLoading: true,
        errorMessage: null,
        consentPointPurposeMaster: null,
      };
    case GetConsentPointPurposeDetailsActions.FETCH_CONSENT_POINT_PURPOSE_DETAILS_FULFILLED:
      return {
        ...state,
        loading: true,
        isLoading: false,
        consentPointPurposeMaster: payload.data,
        errorMessage: null,
      };
    case GetConsentPointPurposeDetailsActions.FETCH_CONSENT_POINT_PURPOSE_DETAILS_REJECTED:
      return {
        ...state,
        isLoading: false,
        errorMessage: payload,
        consentPointPurposeMaster: null,
      };
    case ConsentPointUnSubscribeOrRenewActions.SET_UNSUBSCRIBE_OR_RENEW_CONSENT_POINT_PURPOSE_DETAILS_REJECTED:
      return {
        ...state,
        isLoading: false,
        errorMessage: payload,
      };
    default:
      return state;
  }
}
